<div class="container-fluid">
    <div class="d-flex m-2">
        <div class=" mr-2">
            <button mat-icon-button (click)="back()">
                <mat-icon style="color: #00FF00;" svgIcon="feather:arrow-left-circle"></mat-icon>
            </button>
        </div>
        <h2 class="h3 createHeading">ATTENDANCE LOGS-PERIODS</h2>
    </div>

    <div class="card dataCard m-2" *ngFor="let row of attendanceLogsWithPeriods">
        <div class="row p-2 d-flex align-items-center">

            <div class="col-3 ml-1">
                <h5>Log:</h5>
                <div class="">
                    <span class="listFont">Check-In:</span> {{row.attendance_log_with_totals?.check_in_date_time |
                    date:'dd-MM-YYYY, h:mm a'}}
                </div>
                <div class="">
                    <span class="listFont">Check-Out:</span> {{row.attendance_log_with_totals?.check_out_date_time |
                    date:'dd-MM-YYYY, h:mm a'}}
                </div>
                <div class="">
                    <span class="listFont">Regular Time:</span> {{row.attendance_log_with_totals?.regular_time_in_secs}}
                </div>
                <div class="">
                    <span class="listFont">Off Peak Time:</span>
                    {{row.attendance_log_with_totals?.off_peak_time_in_secs}}
                </div>
                <div class="">
                    <span class="listFont">Total Time:</span>
                    {{row.attendance_log_with_totals?.total_active_time_in_secs}}
                </div>
            </div>

            <div class="col-8">
                <h6>Log-Periods:</h6>
                <table class="table table-bordered" style="width: 85%;;">
                    <thead class="thead-dark" style="background: #000;color: #fff;">
                        <tr>
                            <th scope="col" class="">Start Time</th>
                            <th scope="col" class="">End Time</th>
                            <th scope="col" class="">Used Time</th>
                            <th scope="col" class="">Charged Time</th>
                            <th scope="col" class="">Off-Peak Percentage</th>
                        </tr>
                    </thead>
                    <tbody style="background-color: #fff;" *ngFor="let rowPeriod of row.attendance_log_periods">
                        <tr>
                            <td class="">
                                <span *ngIf="rowPeriod?.start_date_time">{{rowPeriod.start_date_time | date:'dd-MM-YYYY,
                                    h:mm a'}}</span>
                            </td>
                            <td class="">
                                <span *ngIf="rowPeriod?.end_date_time">{{rowPeriod.end_date_time | date:'dd-MM-YYYY,
                                    h:mm a'}}</span>
                            </td>
                            <td class="">
                                <span *ngIf="rowPeriod?.used_time_in_secs">{{rowPeriod.used_time_in_secs}}</span>
                            </td>
                            <td class="">
                                <span *ngIf="rowPeriod?.charged_time_in_secs">{{rowPeriod.charged_time_in_secs}}</span>
                            </td>
                            <td class="">
                                <span *ngIf="rowPeriod?.pro_rata_percentage">{{rowPeriod?.pro_rata_percentage}}%</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </div>
    </div>
</div>